'use client';

import React from 'react';
import { noop } from 'utils/noop';

export type PopoverColors = 'secondary' | 'neutral';

type PopoverContextType = {
  onRequestClose: () => void;
  color: PopoverColors;
  zIndex: number | undefined;
};

export const PopoverContext = React.createContext<PopoverContextType>({
  onRequestClose: noop,
  color: 'secondary',
  zIndex: undefined,
});
